module.exports = __webpack_public_path__ + "img/logo_thwi_w.5768ae3a.png";